import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { filterDropdown_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { validationsList_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";


declare var ko: any;

export class taskTree_template extends vnTemplate {
    protected filter: filterSimple_template;
    public typeFilter: filterDropdown_template;
    public brandFilter: filterDropdown_template;
    public pagination: pagination_template;
    public validationsList: validationsList_template;

    constructor(id: string, vm: any, caller: any) {
        super(id, vm, caller);
    }

    protected getTemplateHtml(): string {
        return `

                <div class="sub-header w-justify" >
                    <div class="w-left">
                           <div><label class="form-label" for="" >Brands</label>` + this.brandFilter.getHtmlBuild()  +`</div>
                    </div>
                    <div class="w-center"></div>
                    <div class="w-right"></div>
                </div>
                <div id="tree-container" class="tree-container" style="width:100%; padding:20px; background:#f5f7fa; box-sizing:border-box;">
                    <!-- ko foreach: tasks -->
                    <div class="root-chart-container" style="margin-bottom:40px; background:#fff; padding:15px; border-radius:6px; box-shadow:0 2px 5px rgba(0,0,0,0.1);">
                        <div class="root-header" style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">
                            <span class="root-title" data-bind="text: operationName" style="font-size:1.2em; font-weight:600; color:#333;"></span>
                            <span class="root-type" data-bind="text: type" style="font-style:italic; color:#666; font-size: 17px"></span>
                        </div>
                        <div class="mermaid" data-bind="attr: { id: 'mermaid-' + operationId }, text: mermaidCode"></div>
                    </div>
                    <!-- /ko -->
                </div>
        `;
    }

    protected initPartial(): void {
        const vm = this.getTemplateViewModel();
        this.filter = new filterSimple_template("filter", vm, this.caller);
        this.typeFilter = new filterDropdown_template("typeFilter", vm, this.caller);
        this.brandFilter= new filterDropdown_template("selectedBrand", vm, this.caller);
        this.pagination = new pagination_template("pagination", vm, this.caller);
        this.validationsList = new validationsList_template("validationList", vm, this);
    }

    protected buildViewModel(): any {
        const vm: any = {};
        vm.tasks         = ko.observableArray([]);
        vm.selectedBrand = ko.observable('');
        vm.onClickRefresh = () => this.caller.refreshTree();
        return vm;
    }

    protected getTemplateName(): string {
        return "taskTree-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content", "task-tree"];
    }

    public getViewModelForRequest() {
        const vm = this.getTemplateViewModel();
        const brandFilterVm = vm.selectedBrand;
        return {
            brand: brandFilterVm.selectedOption(),
        };
    }

    public setTasks(data: any): void {
        const rawRoots: any[] = Array.isArray(data) ? data : Object.values(data);
        const vm: any = this.getTemplateViewModel();

        // Build Mermaid graph syntax for each root
        const buildMermaidCode = (node: any): string => {
            const lines: string[] = ["graph LR"];
            (function traverse(n: any) {
                lines.push(`${n.operationId}["${n.operationName}"]`);
                const children = Array.isArray(n.child) ? n.child : Array.isArray(n.children) ? n.children : [];
                children.forEach((ch: any) => {
                    lines.push(`${n.operationId} --> ${ch.operationId}`);
                    traverse(ch);
                });
            })(node);
            return lines.join("\n");
        };

        // Prepare wrapped data with mermaidCode
        const wrapped = rawRoots.map(root => ({
            operationId: root.operationId,
            operationName: root.operationName,
            type: 'Trigger Source: ' + root.type,
            mermaidCode: buildMermaidCode(root)
        }));

        // Populate tasks
        vm.tasks(wrapped);

        // Load Mermaid if needed and then render all diagrams
        const loadMermaid = (cb: () => void) => {
            if ((window as any).mermaid) {
                cb();
            } else {
                const script = document.createElement("script");
                script.src = "https://cdn.jsdelivr.net/npm/mermaid/dist/mermaid.min.js";
                script.onload = cb;
                document.head.appendChild(script);
            }
        };

        setTimeout(() => {
            loadMermaid(() => {
                const mermaidAPI = (window as any).mermaid;
                mermaidAPI.initialize({ startOnLoad: false });
                // auto-render all .mermaid containers
                mermaidAPI.init(undefined, document.querySelectorAll('.mermaid'));
            });
        }, 0);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/taskTree_template.ts